import React from 'react'
import propTypes from 'prop-types'

const Text = (props) => {
  const text = props.children
  if (text) {
    const parts = text.split('\n')

    const elements = []
    parts.forEach(part => {
      if (elements.length > 0) elements.push(<br key={elements.length}/>)
      elements.push(<span key={elements.length}>{part}</span>)
    })

    return <span className="textString">{elements}</span>
  }
  return null
}

Text.propTypes = {
  children: propTypes.string.isRequired,
}

export default Text
